import React from "react";
import RightArrow from './RightArrow';

const LeftArrow = ({ fill, svgIconSize }) => {
    return (
        <RightArrow transform={'scaleX(-1)'} fill={fill} svgIconSize={svgIconSize} />
    );
};

export default LeftArrow;
